// src/app/state/reducers/theme.reducer.ts

import { createReducer, on } from '@ngrx/store';
import * as ThemeActions from '../actions/theme.actions';
import { ThemeData } from '../models/theme.model';

export const initialState: ThemeData = {
  theme: 'theme-light',
  docViewerLeftSideCollapsible: true,
  docViewerRightSideCollapsible: true
};

export const themeReducer = createReducer(
  initialState,
  on(ThemeActions.changeToDarkTheme, (state) => ({
    ...state,
    theme: 'theme-dark'
  })),
  on(ThemeActions.changeToLightTheme, (state) => ({
    ...state,
    theme: 'theme-light'
  })),
  on(ThemeActions.setDocViewerLeftSideCollapsible, (state, { value }) => ({
    ...state,
    docViewerLeftSideCollapsible: value
  })),
  on(ThemeActions.setDocViewerRightSideCollapsible, (state, { value }) => ({
    ...state,
    docViewerRightSideCollapsible: value
  }))
);
